<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title"></div>
        <v-row class="ma-0">
          <v-col cols="auto" class="pa-0 py-0">
            <div v-if="salarie.avatar" class="list-logo" style="height: 96px; width: 96px;">
              <img :src="salarie.avatar" width="100%"/>
            </div>
            <div class="logo-initial" v-else>{{ getInitials(salarie) }}</div>
          </v-col>
          <v-col class="py-0 align-content-center" style="padding-left: 16px !important; flex: 1 1 0;">
            <div class="section-abstract-title-header pb-2">{{ salarie.prenom }} {{ salarie.nom }}</div>
            <div class="section-abstract-subtitle-header">{{ salarie.pseudo }}</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from "vue";
  import SectionSalarieIdentiteAbstract from '@/generated/sections/SectionSalarieIdentiteAbstract.vue';
  import Salarie from "@/extend/classes/Salarie";
  export default defineComponent({
    extends: SectionSalarieIdentiteAbstract,
    components: {},
    methods: {
      getInitials(salarie: Salarie): string {
        const p = (salarie.prenom ?? '').trim();
        const n = (salarie.nom ?? '').trim();
        const a = p.length > 0 ? p[0] : '';
        const b = n.length > 0 ? n[0] : '';
        return (a + b).toUpperCase();
      }
    }
  })
</script>
